import gql from 'graphql-tag'

export const deletePendingOrder = gql`
query ($cart_id: String!) {
  deletePreOrder(
    cart_id: $cart_id
  ) {
    message,
    status
  }
}`
